import { render, staticRenderFns } from "./PaymentsList.vue?vue&type=template&id=50619e6d&"
import script from "./PaymentsList.vue?vue&type=script&lang=js&"
export * from "./PaymentsList.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports